import React, {Component} from "react";
import defaultBillboardImage from "../images/default-billboard.jpeg";
import {CalcOverride, getUrlExtension} from "../helpers/Helpers";
import {ReactComponent as HeartSVG} from "../images/heart.svg";
import Axios from "axios";
import UrlExists from 'url-exist-sync';
import {UpdateStatus} from "../helpers/APIWrappers/Campaign";
import {Col} from "react-bootstrap";
import moment from "moment";

export default class BoardCard extends Component {

    //duplicated code
    toggleFavorite = () => {
        let boardId = this.props.boardKey;
        let status = "favorite";
        if (this.props.board.status === 'favorite'){
            status = "";
        }
        Axios.post(process.env.REACT_APP_BACKEND_URL + "/campaign/toggle-favorite", {
            boardId: boardId,
            campaignId:this.props.campaign._id,
            status :  status,
        },{
            headers: {
                'content-type': 'application/json'
            }
        }).then(response => {
            let board =  this.props.board;
            board.status = status;
            this.props.updateBoard(boardId,board)
            // this.setState({});
        }).catch(error => {
            console.log(error)
        });
    }
    updateStatus = (status) => {
        UpdateStatus(this.props.boardKey,this.props.campaign._id,status, (board)=>{
            this.props.updateBoard(this.props.boardKey,board)
        });
    }

    render() {
        let { board, child, toggleExpanded, expanded, pin } = this.props;
        let override = CalcOverride(board);
        return <div className={"board-card " + this.props.sidebarFormat + (child ? " board-child" : "")}
            onMouseEnter={() => {
                if (this.props.centerMap) {
                    this.props.centerMap(board.lat, board.lon)
                }
                if (this.props.onHover) {
                    this.props.onHover();
                }
            }}
            onMouseLeave={() => {
                if (this.props.leaveHover) {
                    this.props.leaveHover();
                }
            }}
            onClick={(e) => {
                e.stopPropagation();
                this.props.selectBoard(board.vendorId);
            }}>
            <div className={"board-card-left" + (pin && expanded ? " expanded-pin" : "")}>
                {function (){
                    if(board.images.length && getUrlExtension(board.images[0])=== "pdf"){
                        return <embed src={board.images[0]}/>
                    }else if(board.images.length){
                        return <img src={board.images[0]} alt="billboard header"/>
                    }
                    return <img src={`https://sorter.s3.amazonaws.com/telos/${this.props.campaign._id}/${escape(board.vendorId)}.png`}
                                onError={(e)=>{e.target.onerror = null; e.target.src=defaultBillboardImage}}
                                alt="billboard header"/>
                }.bind(this)()}
            </div>
            <div className={"board-card-right"}>
                {!child && <div className={"heart-container "+(board.status === "favorite"?" favorite":"")} onClick={event => {
                    event.stopPropagation();
                    this.toggleFavorite();
                }}>
                    <HeartSVG/>
                </div>}
                <div className={"d-flex"} style={{justifyContent:"space-between"}}>
                    <p className={"board-card-title"}>{board.fields["unit #"]} ~ {board.fields.description}</p>
                    {!child && <select className={"mt-2 text-capitalize"} style={{fontSize:"11px",width:"81px",height:"20px",flex: "0 0 80px"}} value={board.status}
                            disabled={!this.props.isOwner && !(!board.status || board.status === "favorite")}
                            onClick={(event)=>event.stopPropagation()}
                            onChange={(ev)=>{
                                this.updateStatus(ev.target.value);
                            }}>
                        <option value={""}></option>
                        <option value={"favorite"}>Favorite</option>
                        {this.props.isOwner ?
                            <>
                                <option value={"requested"}>Requested</option>
                                <option value={"unavailable"}>Unavailable</option>
                                <option value={"confirmed"}>Confirmed</option>
                                <option value={"posted"}>Posted</option>
                                <option value={"completed"}>Completed</option>
                            </>
                            :""}
                        {!this.props.isOwner && ![undefined,"","favorite"].includes(board.status) ?
                            <option value={board.status}>{board.status}</option> :""
                        }
                    </select>}
                </div>

                {/*<p className={"board-card-subtitle"}>{board.address}</p>*/}
                {/*<p className={"board-card-subtitle"}>${board.fields["Buying Total Cost  (Media + Production + Installation)"]} - {board.fields["4-Wk Impressions"]} Impressions - {board.fields["Size (H x W)"]}</p>*/}
                {["posted","completed"].includes(board.status) ? <>
                    <p className={"board-card-subtitle"}>
                         <span className={
                             "media-format "+(board.fields["media format"] ? board.fields["media format"].toLowerCase() : "")
                             + (board.fields["digital (y/n)"] === "Y" ? " digital": "")
                         }
                         />
                        {board.fields["digital (y/n)"] === "Y" ? "Digital ": ""}
                        {board.fields["media format"]}
                        <span className={"ml-3"}>Flight: {moment(board.fields["start date"]).format('M/D')} - {moment(board.fields["end date"]).format('M/D')}</span>
                    </p>
                    <div className={"fields-list"}>
                        {
                            override.overridePercent ? <div className={"green-btn ft-sm"}>{override.overridePercent} Override</div>:<></>
                        }
                        {
                            board.fields["install date"] ? <div className={"d-inline-block ft-md"}><b>Install:</b> {moment(board.fields["install date"]).format('M/D')}</div> : <></>
                        }
                        {
                            board.fields["takedown date"] ? <div className={"d-inline-block ft-md"}><b>Takedown:</b> {moment(board.fields["takedown date"]).format('M/D')}</div> : <></>
                        }
                    </div>
                    </>:<>
                    <p className={"board-card-subtitle"}>
                         <span className={
                             "media-format "+(board.fields["media format"] ? board.fields["media format"].toLowerCase() : "")
                             + (board.fields["digital (y/n)"] === "Y" ? " digital": "")
                         }
                         />
                        {board.fields["digital (y/n)"] === "Y" ? "Digital ": ""}
                        {board.fields["media format"]} - {board.fields["h x w"] ? board.fields["h x w"] : board.fields["size (h x w)"]}
                        <span className={"ml-3"}>{moment(board.fields["start date"]).format('M/D')} - {moment(board.fields["end date"]).format('M/D')}</span>
                    </p>
                        {!child && <div className={"fields-list"}>
                            <div>
                                {
                                    board.fields["cpm"] ? <div className={"yellow-btn ft-sm"}>${Math.round(board.fields["cpm"] * 100) / 100} CPM</div> : <></>
                                }
                                {
                                    board.fields["4-wk trp"] ? <div className={"yellow-btn ft-sm"}>${Math.round(board.fields["4-wk trp"] * 100) / 100} TRP</div> : <></>
                                }
                                {this.props.campaign.complianceOn ?
                                    <>
                                        {board.complianceArray && board.complianceArray.length ?
                                            <div className={"red-btn ft-sm"}>Compliance</div> :
                                            <div className={"green-btn ft-sm"}>Compliance</div>
                                        }
                                    </>
                                    : <></>}
                            </div>
                            {board.childBoards && <span onClick={toggleExpanded} >
                                {expanded ? '- Collapse' : `+ Expand (${board.childBoards.length})`}
                            </span>}
                        </div>}
                </>}
            </div>
        </div>;
    }
}
